import { Font, StyleSheet } from '@react-pdf/renderer';

Font.registerHyphenationCallback(word => {
  if (word.length > 10) {
    const parts = [];
    const chunkSize = 8;
    for (let i = 0; i < word.length; i += chunkSize) {
      parts.push(word.slice(i, i + chunkSize));
    }
    return parts;
  }
  return [word];
});

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 25,
  },
  footerText: {
    color: 'white',
    fontSize: 12,
    fontFamily: 'Lato',
    fontWeight: 900,
    paddingLeft: 25,
    paddingRight: 25,
  },
  logo: { width: 85, height: 17, zIndex: 4 },
  logosWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 12,
    paddingTop: 8,
    paddingBottom: 8,
  },
  eventHeaderLogoWrapper: {
    position: 'absolute',
    top: 30,
    right: 80,
    width: 140,
    height: 60,
    zIndex: 5,
  },
  eventHeaderLogo: {
    width: 'auto',
    height: '100%',
  },
  bodyContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  leftSideBody: {
    flex: '0 0 56%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rightSideBody: {
    flex: '0 0 44%',
    paddingRight: 50,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 30,
  },
  bigEventLogo: {
    width: 300,
    height: 200,
  },
  title: {
    fontSize: 42,
    fontFamily: 'Lato',
    fontWeight: 900,
    textTransform: 'uppercase',
    width: 270,
  },
  regularText: {
    fontSize: 10,
    fontFamily: 'Lato',
    fontWeight: 300,
    width: 270,
  },
  boldText: {
    fontSize: 26,
    fontFamily: 'Lato',
    fontWeight: 900,
    width: 270,
    color: 'white',
    textAlign: 'center',
  },
  quoteText: {
    fontSize: 12,
    fontFamily: 'Lato',
    fontWeight: 300,
    width: 270,
    color: 'white',
    textAlign: 'center',
  },
  itemsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 70,
    paddingLeft: 27,
    paddingTop: 20,
    paddingRight: 40,
    flexWrap: 'wrap',
  },
  bodyTitle: {
    fontSize: 45,
    fontFamily: 'Lato',
    fontWeight: 900,
    textTransform: 'uppercase',
    paddingLeft: 27,
    lineHeight: 0.6,
  },
  bodyLineBar: {
    width: 60,
    borderTop: '10px solid black',
    marginRight: 'auto',
    marginTop: 18,
  },
  textSpace: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  },
  regularBodyText: {
    fontSize: 12,
    fontFamily: 'Lato',
    fontWeight: 300,
    paddingLeft: 27,
    paddingRight: 100,
  },
  whiteTitle: {
    fontSize: 44,
    fontFamily: 'Lato',
    fontWeight: 900,
    textTransform: 'uppercase',
    width: 270,
    color: 'white',
    paddingLeft: 30,
  },
  whiteBodyLineBar: {
    width: 60,
    borderTop: '11px solid white',
    marginRight: 'auto',
    marginTop: 18,
  },
  speakersWrapper: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    width: 525,
    gap: 6,
    right: 35,
    top: 60,
    bottom: 70,
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  speakerItem: {
    display: 'flex',
    flexDirection: 'column',
    border: '2px solid black',
    height: 230,
    width: 100,
  },
  speakerImageWrapper: {
    width: 96,
    height: 100,
  },
  speakerLogoWrapper: {
    width: 96,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  speakerLogo: {
    width: 96,
    height: 100,
  },
  speakerCompanyLogo: {
    width: 96,
    height: 40,
  },

  speakerBodyCard: {
    height: 90,
    width: 96,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#333333',
  },
  speakerName: {
    height: 40,
    padding: 5,
  },
  speakerCompanyName: {
    height: 50,
    padding: 5,
  },
  speakerNameText: {
    fontSize: 12,
    fontFamily: 'Lato',
    fontWeight: 900,
    textTransform: 'uppercase',
    color: 'white',
  },
  speakerCompanyNameText: {
    fontSize: 7,
    fontFamily: 'Lato',
    fontWeight: 500,
    color: 'white',
  },
  eventTitle: {
    fontSize: 17,
    color: 'black',
    fontWeight: 400,
    fontFamily: 'Lato',
    paddingLeft: 28,
  },
  keyTopicsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    paddingLeft: 28,
    paddingRight: 28,
    height: 400,
    bottom: 35,
    position: 'relative',
  },
  keyTopicsColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: 245,
  },
  keyTopicsItem: {
    display: 'flex',
    gap: 10,
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  lightText: {
    fontSize: 11,
    fontFamily: 'Lato',
    fontWeight: 300,
  },
  whoWhyPageWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 40,
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 570,
  },
  whoWhyTitle: {
    fontSize: 33,
    color: 'black',
    fontWeight: 900,
    fontFamily: 'Lato',
    paddingLeft: 25,
    paddingRight: 25,
    paddingTop: 58,
    paddingBottom: 20,
  },
  whoWhyTitleWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRight: '12px solid black',
    borderLeft: '12px solid black',
    borderBottom: '12px solid black',
    transform: 'rotate(-90deg)',
    position: 'relative',
    right: 70,
  },
  multiTouchPointsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
    width: 614,
    height: 479,
    position: 'absolute',
    top: 50,
    bottom: 30,
    right: 30,
  },
  multiTouchPointsItem: {
    width: 198,
    height: 153,
    paddingTop: 13,
    paddingBottom: 5,
    paddingLeft: 13,
    paddingRight: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: 9,
    backgroundColor: 'black',
  },
  multiTouchPointItemTitle: {
    fontSize: 10,
    fontFamily: 'Lato',
    fontWeight: 900,
    color: 'white',
  },
  multiTouchPointBodyWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: 7,
  },
  multiTouchTextWrapper: {
    width: 80,
    height: 100,
  },
  multiTouchImageWrapper: {
    width: 120,
    height: 80,
    backgroundColor: 'white',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  whiteSubtitle: {
    fontSize: 8,
    fontFamily: 'Lato',
    fontWeight: 700,
    color: 'white',
    breakWord: 'word-break',
  },
  increaseSalesItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  matchMakingItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  matchMakingTitle: {
    fontSize: 12,
    fontFamily: 'Lato',
    fontWeight: 900,
    color: 'black',
  },
  matchMakingBody: {
    fontSize: 10,
    fontFamily: 'Lato',
    fontWeight: 300,
    color: 'black',
  },
  increaseSalesTitle: {
    fontSize: 15,
    fontFamily: 'Lato',
    fontWeight: 900,
    color: 'black',
  },
  increaseSalesBody: {
    fontSize: 13,
    fontFamily: 'Lato',
    fontWeight: 300,
    color: 'black',
  },
  increaseSalesWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    paddingLeft: 28,
    paddingRight: 28,
    height: 400,
  },
  matchMakingColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    width: 200,
  },
  serviceTitle: {
    fontSize: 15,
    color: 'black',
    fontWeight: 400,
    fontFamily: 'Lato',
    paddingLeft: 28,
  },
  IconBarWrapper: {
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: 28,
    paddingRight: 35,
    paddingTop: 20,
    paddingBottom: 10,
  },
  serviceLineBar: {
    width: 210,
    borderTop: '14px solid black',
    alignSelf: 'center',
  },
  arrow: {
    width: 0,
    height: 0,
    margin: 0,
    borderTop: '15px solid white',
    borderBottom: '15px solid white',
    borderLeft: '25px solid black',
    alignSelf: 'center',
  },
  serviceThatConvinceWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    paddingLeft: 28,
    paddingRight: 28,
    paddingTop: 20,
    height: 230,
  },
  serviceThatConvinceTitle: {
    fontSize: 17,
    fontFamily: 'Lato',
    fontWeight: 900,
    color: 'black',
    textTransform: 'uppercase',
  },
  participantSubtitle: {
    fontSize: 16,
    fontFamily: 'Lato',
    fontWeight: 400,
    width: 270,
    color: 'white',
    paddingLeft: 28,
    paddingTop: 10,
  },
  participantEventSubtitle: {
    fontSize: 16,
    fontFamily: 'Lato',
    fontWeight: 900,
    color: 'white',
  },
  participantFeedbackRightWrapper: {
    width: 432,
    height: 500,

    position: 'absolute',
    top: 35,
    right: 40,
    bottom: 30,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  testimonialItem: {
    width: 211,
    height: 160,
    border: '4px solid #333333',
    display: 'flex',
    flexDirection: 'column',
  },
  testimonialItemHeader: {
    backgroundColor: '#333333',
    padding: '5 8',
    height: 80,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  testimonialItemBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: 5,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    backgroundColor: 'white',
    gap: 6,
  },
  testimonialItemHeaderText: {
    fontSize: 7,
    fontFamily: 'Lato',
    fontWeight: 900,
    color: 'white',
    textAlign: 'center',
    breakWord: 'word-break',
    width: 150,
    paddingTop: 5,
    paddingBottom: 5,
  },
  participantLogoWrapper: {
    width: 120,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  attendeeListSubtitle: {
    fontSize: 12,
    fontFamily: 'Lato',
    fontWeight: 900,
    color: 'black',
    alignSelf: 'flex-start',
    paddingLeft: 38,
  },
  buttonWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexDirection: 'row',
    position: 'absolute',
    right: 33,
    top: 310,
  },
  button: {
    color: 'white',
    fontSize: 16,
    textTransform: 'uppercase',
    paddingTop: 21,
    paddingBottom: 21,
    paddingRight: 26,
    paddingLeft: 26,
    borderRadius: 5,
  },
  hand: {
    position: 'relative',
    width: 'auto',
    height: 34,
    right: 34,
    top: 15,
  },
  packagePriceSubtitle: {
    fontSize: 13,
    fontFamily: 'Lato',
    fontWeight: 900,
    color: 'black',
    position: 'absolute',
    top: 170,
    right: 142,
  },
  partnerDetailSubtitle: {
    fontSize: 22,
    fontFamily: 'Lato',
    fontWeight: 700,
    color: 'black',
    paddingLeft: 28,
    paddingTop: 10,
  },
  partnerDetailLineBar: {
    width: '100%',
    borderTop: '10px solid black',
  },
  partnerDetailsHeader: {
    paddingLeft: 28,
    paddingRight: 70,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  partnerDetailsHeaderText: {
    fontSize: 16,
    fontFamily: 'Lato',
    fontWeight: 700,
    color: 'white',
    backgroundColor: 'black',
    padding: '10 20',
    textTransform: 'uppercase',
  },
  partnerDetailsBody: {
    fontSize: 10,
    fontFamily: 'Lato',
    fontWeight: 300,
    color: 'black',
  },
  partnerDetailsBodyWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    paddingLeft: 28,
    paddingRight: 28,
    height: 325,
  },
  partnerDetailsItem: {
    paddingTop: 15,
    display: 'flex',
    flexDirection: 'row',
    gap: 15,
  },
  partnerDetailsFooter: {
    position: 'absolute',
    bottom: 10,
    right: 28,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 200,
    height: 900,
    gap: 5,
  },
  partnerDetailsFooterPrice: {
    fontSize: 30,
    fontFamily: 'Lato',
    fontWeight: 900,
    color: 'black',
    border: '3px solid black',
    padding: '3 25',
  },
  bookNowButton: {
    fontSize: 16,
    fontFamily: 'Lato',
    fontWeight: 900,
    color: 'white',
    padding: '5 10',
    textTransform: 'uppercase',
  },
  contactUsBody: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    alignItems: 'flex-start',
    paddingLeft: 28,
    paddingRight: 28,
  },
  contactUsBodyItem: {
    paddingTop: '15 8 8 8',
    border: '1px solid black',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 200,
    width: 190,
  },
  footerButton: {
    width: '100%',
    padding: '8 10',
    fontSize: 8,
    fontFamily: 'Lato',
    fontWeight: 900,
    color: 'white',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  footerButtonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    padding: 7,
  },
  contactUsBodyHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 40,
    width: '100%',
  },
  contactUsBodyText: {
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 300,
    color: 'black',
    textTransform: 'uppercase',
  },
  hexagonal: {
    width: 53,
    height: 53,
    transform: 'rotate(-90deg)',
    position: 'relative',
    bottom: 0,
    right: 0,
  },
  whiteIconWrapper: {
    position: 'relative',
    bottom: 37,
    right: -14,
  },
});
